'use client';

import { c as _c } from "react/compiler-runtime";
import { Link, usePathname } from "@/i18n/routing";
import type { ReactNode } from "react";
interface MenuLinkProps {
  children: ReactNode;
  href: string;
  closeMenu: () => void;
  className?: string;
  onClick?: () => void;
}
export default function MenuLink(props) {
  const $ = _c(10);
  const {
    children,
    href,
    onClick,
    closeMenu,
    className
  } = props;
  const pathname = usePathname();
  let t0;
  if ($[0] !== closeMenu || $[1] !== href || $[2] !== onClick || $[3] !== pathname) {
    t0 = () => {
      if (onClick) {
        onClick();
      }
      if (pathname === href) {
        closeMenu();
      }
    };
    $[0] = closeMenu;
    $[1] = href;
    $[2] = onClick;
    $[3] = pathname;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const handleClick = t0;
  let t1;
  if ($[5] !== children || $[6] !== className || $[7] !== handleClick || $[8] !== href) {
    t1 = <Link className={className} href={href} onClick={handleClick}>{children}</Link>;
    $[5] = children;
    $[6] = className;
    $[7] = handleClick;
    $[8] = href;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
}